import React from 'react';
// import { NavLink } from 'react-router-dom';


class ManagingPartner extends React.Component {
    render() {
        return (
            <>
                {/* ABOUT TEAM MEMBER SECTION START */}
                <div className="section-full p-tb80 bg-white mobile-page-padding">
                    <div className="container">
                        <div className="section-content ">
                            <div className="about-team-member text-black">
                                <div className="sx-box m-b30">
                                    <h3 className="m-t0 m-b20">Managing <span className="sx-text-primary"> Partners</span></h3>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="about-single-team-info-left">
                                            <div className='row'>
                                                <div className="col-lg-6 col-md-6 col-sm-6">
                                                    <div className="profile-image p-a5 sx-bg-secondry">
                                                        <img src={require('./../../images/our-team5/SaumyaKumarThakur.jpg')} alt="" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 p-l0">
                                                    <div className="text-black bg-white partnertName">
                                                        <h4 className="m-t0 sx-text-primary m-b5">Saumya Kumar Thakur</h4>
                                                        <h5 className="m-b0">Founder and Partner</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="about-single-team-info m-t30">
                                            <div className="our-exp">
                                                <p className='text-justify'>Madhuban Contracts LLP has been founded by <b>Saumya Kumar Thakur</b>, a Veteran in the Construction Industry of nearly more than three decades and experience in Working in very Senior Position in the Country.</p>
                                                <p className='text-justify'>Before establishing MCLLP, he has worked in Companies like Tata Steel , Shaporjii &Pallonji , Mfar Construction and Ambuja Realty.</p>
                                                <p className='text-justify m-b0'>He set up the Eastern Zone Operations of Mfar construction Pvt. Ltd<b> (a subsidiary of Galfar Construction LLP , One of the largest construction Company in the Gulf)</b> and the Company became a major Construction company in the Eastern India during his tenure.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-6 m-t50xs">
                                        <div className="about-single-team-info-left">
                                            <div className='row'>
                                                <div className="col-lg-6 col-md-6 col-sm-6">
                                                    <div className="profile-image p-a5 sx-bg-secondry">
                                                        <img src={require('./../../images/our-team5/NeelakshiMukherjee.jpg')} alt="" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 p-l0">
                                                    <div className="text-black bg-white partnertName">
                                                        <h4 className="m-t0 sx-text-primary m-b5">Neelakshi Mukherjee</h4>
                                                        <h5 className="m-b0">Partner</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="about-single-team-info m-t30">
                                            <div className="our-exp">
                                                <p className='text-justify'><b>Neelakshi Mukherjee</b>, 2nd partner at Madhuban Contracts is a corporate veteran, with almost 25 years of experience in Human Resource and Corporate Governance. </p>
                                                <p className='text-justify'>She has a diverse work experience in several Service, Manufacturing and Engineering industries. She has worked in various global and Indian markets in organizations like Taj group of hotels, Airtel, Aircel, Startek , to name a few.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 m-t30">
                                        <div className="about-single-team-info">
                                            <div className="about-home-3 bg-gray">
                                                <h5 className="m-t0 m-b10 sx-tilte">TURN OVER</h5>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="sx-icon-box-wraper p-a15 center bg-white shadow">
                                                            <div className="icon-content1">
                                                                <p>2020-21</p>
                                                                <p className='colorbrown'>366.12 Lacs</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="sx-icon-box-wraper p-a15 center bg-white shadow">
                                                            <div className="icon-content1">
                                                                <p>2021-22</p>
                                                                <p className='colorbrown'>755.60 Lacs</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="sx-icon-box-wraper p-a15 center bg-white shadow">
                                                            <div className="icon-content1">
                                                                <p>2022-23</p>
                                                                <p className='colorbrown'>1755.2 Lacs</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="sx-icon-box-wraper p-a15 center bg-white shadow">
                                                            <div className="icon-content1">
                                                                <p>2023-24</p>
                                                                <p className='colorbrown'>2527.29 Lacs</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ABOUT TEAM MEMBER SECTION END */}
            </>
        );
    }
};

export default ManagingPartner;